'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentCreateCertificateOfOriginRequest(number, recipient, originOfGoods, documentaryCredit, placeOfReceipt, placeOfLoading, placeOfDelivery, placeOfDischarge, invoiceNumber, currency, goods, incoterm, shippingMarks, consignee, invoiceDate, purchaseOrderContract, hsCode, issueDate, shipper, manufacturer, vesselOrFlightNumber, voyage, preCarriageVesselOrFlightNumber, sealNumber, containerNumber, shipmentDate, truckNumber, documentNote) {
  this.a77 = null;
  this.a7f = null;
  this.a78 = null;
  this.a6Z = null;
  this.a7c = null;
  this.a7b = null;
  this.a79 = null;
  this.a7a = null;
  this.a74 = null;
  this.a6X = null;
  this.a70 = null;
  this.a72 = null;
  this.a7j = null;
  this.a6V = null;
  this.a73 = null;
  this.a7e = null;
  this.a71 = null;
  this.a75 = null;
  this.a7i = null;
  this.a76 = null;
  this.a7l = null;
  this.a7m = null;
  this.a7d = null;
  this.a7g = null;
  this.a6W = null;
  this.a7h = null;
  this.a7k = null;
  this.a6Y = null;
  this.a77 = number;
  this.a7f = recipient;
  this.a78 = originOfGoods;
  this.a6Z = documentaryCredit;
  this.a7c = placeOfReceipt;
  this.a7b = placeOfLoading;
  this.a79 = placeOfDelivery;
  this.a7a = placeOfDischarge;
  this.a74 = invoiceNumber;
  this.a6X = currency;
  this.a70 = goods;
  this.a72 = incoterm;
  this.a7j = shippingMarks;
  this.a6V = consignee;
  this.a73 = invoiceDate;
  this.a7e = purchaseOrderContract;
  this.a71 = hsCode;
  this.a75 = issueDate;
  this.a7i = shipper;
  this.a76 = manufacturer;
  this.a7l = vesselOrFlightNumber;
  this.a7m = voyage;
  this.a7d = preCarriageVesselOrFlightNumber;
  this.a7g = sealNumber;
  this.a6W = containerNumber;
  this.a7h = shipmentDate;
  this.a7k = truckNumber;
  this.a6Y = documentNote;
}
export { $c_Lapp_data_AppDocumentCreateCertificateOfOriginRequest as $c_Lapp_data_AppDocumentCreateCertificateOfOriginRequest };
$p = $c_Lapp_data_AppDocumentCreateCertificateOfOriginRequest.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentCreateCertificateOfOriginRequest;
/** @constructor */
function $h_Lapp_data_AppDocumentCreateCertificateOfOriginRequest() {
}
export { $h_Lapp_data_AppDocumentCreateCertificateOfOriginRequest as $h_Lapp_data_AppDocumentCreateCertificateOfOriginRequest };
$h_Lapp_data_AppDocumentCreateCertificateOfOriginRequest.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentCreateCertificateOfOriginRequest)) {
    if ((this.a77 === x$0.a77)) {
      var x = this.a7f;
      var x$2 = x$0.a7f;
      var $x_24 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_24 = false;
    }
    if (($x_24 && (this.a78 === x$0.a78))) {
      var x$3 = this.a6Z;
      var x$4 = x$0.a6Z;
      var $x_23 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_23 = false;
    }
    if ($x_23) {
      var x$5 = this.a7c;
      var x$6 = x$0.a7c;
      var $x_22 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_22 = false;
    }
    if ($x_22) {
      var x$7 = this.a7b;
      var x$8 = x$0.a7b;
      var $x_21 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_21 = false;
    }
    if ($x_21) {
      var x$9 = this.a79;
      var x$10 = x$0.a79;
      var $x_20 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_20 = false;
    }
    if ($x_20) {
      var x$11 = this.a7a;
      var x$12 = x$0.a7a;
      var $x_19 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_19 = false;
    }
    if (($x_19 && (this.a74 === x$0.a74))) {
      var x$13 = this.a6X;
      var x$14 = x$0.a6X;
      var $x_18 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_18 = false;
    }
    if ($x_18) {
      var x$15 = this.a70;
      var x$16 = x$0.a70;
      var $x_17 = ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      var $x_17 = false;
    }
    if ($x_17) {
      var x$17 = this.a72;
      var x$18 = x$0.a72;
      var $x_16 = ((x$17 === null) ? (x$18 === null) : x$17.f(x$18));
    } else {
      var $x_16 = false;
    }
    if ($x_16) {
      var x$19 = this.a7j;
      var x$20 = x$0.a7j;
      var $x_15 = ((x$19 === null) ? (x$20 === null) : x$19.f(x$20));
    } else {
      var $x_15 = false;
    }
    if ($x_15) {
      var x$21 = this.a6V;
      var x$22 = x$0.a6V;
      var $x_14 = ((x$21 === null) ? (x$22 === null) : x$21.f(x$22));
    } else {
      var $x_14 = false;
    }
    if ($x_14) {
      var x$23 = this.a73;
      var x$24 = x$0.a73;
      var $x_13 = ((x$23 === null) ? (x$24 === null) : x$23.f(x$24));
    } else {
      var $x_13 = false;
    }
    if ($x_13) {
      var x$25 = this.a7e;
      var x$26 = x$0.a7e;
      var $x_12 = ((x$25 === null) ? (x$26 === null) : x$25.f(x$26));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$27 = this.a71;
      var x$28 = x$0.a71;
      var $x_11 = ((x$27 === null) ? (x$28 === null) : x$27.f(x$28));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$29 = this.a75;
      var x$30 = x$0.a75;
      var $x_10 = ((x$29 === null) ? (x$30 === null) : x$29.f(x$30));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$31 = this.a7i;
      var x$32 = x$0.a7i;
      var $x_9 = ((x$31 === null) ? (x$32 === null) : x$31.f(x$32));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$33 = this.a76;
      var x$34 = x$0.a76;
      var $x_8 = ((x$33 === null) ? (x$34 === null) : x$33.f(x$34));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$35 = this.a7l;
      var x$36 = x$0.a7l;
      var $x_7 = ((x$35 === null) ? (x$36 === null) : x$35.f(x$36));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$37 = this.a7m;
      var x$38 = x$0.a7m;
      var $x_6 = ((x$37 === null) ? (x$38 === null) : x$37.f(x$38));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$39 = this.a7d;
      var x$40 = x$0.a7d;
      var $x_5 = ((x$39 === null) ? (x$40 === null) : x$39.f(x$40));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$41 = this.a7g;
      var x$42 = x$0.a7g;
      var $x_4 = ((x$41 === null) ? (x$42 === null) : x$41.f(x$42));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$43 = this.a6W;
      var x$44 = x$0.a6W;
      var $x_3 = ((x$43 === null) ? (x$44 === null) : x$43.f(x$44));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$45 = this.a7h;
      var x$46 = x$0.a7h;
      var $x_2 = ((x$45 === null) ? (x$46 === null) : x$45.f(x$46));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$47 = this.a7k;
      var x$48 = x$0.a7k;
      var $x_1 = ((x$47 === null) ? (x$48 === null) : x$47.f(x$48));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$49 = this.a6Y;
      var x$50 = x$0.a6Y;
      return ((x$49 === null) ? (x$50 === null) : x$49.f(x$50));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 28;
});
$p.t = (function() {
  return "AppDocumentCreateCertificateOfOriginRequest";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.a77;
      break;
    }
    case 1: {
      return this.a7f;
      break;
    }
    case 2: {
      return this.a78;
      break;
    }
    case 3: {
      return this.a6Z;
      break;
    }
    case 4: {
      return this.a7c;
      break;
    }
    case 5: {
      return this.a7b;
      break;
    }
    case 6: {
      return this.a79;
      break;
    }
    case 7: {
      return this.a7a;
      break;
    }
    case 8: {
      return this.a74;
      break;
    }
    case 9: {
      return this.a6X;
      break;
    }
    case 10: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector(this.a70);
      break;
    }
    case 11: {
      return this.a72;
      break;
    }
    case 12: {
      return this.a7j;
      break;
    }
    case 13: {
      return this.a6V;
      break;
    }
    case 14: {
      return this.a73;
      break;
    }
    case 15: {
      return this.a7e;
      break;
    }
    case 16: {
      return this.a71;
      break;
    }
    case 17: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(this.a75);
      break;
    }
    case 18: {
      return this.a7i;
      break;
    }
    case 19: {
      return this.a76;
      break;
    }
    case 20: {
      return this.a7l;
      break;
    }
    case 21: {
      return this.a7m;
      break;
    }
    case 22: {
      return this.a7d;
      break;
    }
    case 23: {
      return this.a7g;
      break;
    }
    case 24: {
      return this.a6W;
      break;
    }
    case 25: {
      return this.a7h;
      break;
    }
    case 26: {
      return this.a7k;
      break;
    }
    case 27: {
      return this.a6Y;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "number";
      break;
    }
    case 1: {
      return "recipient";
      break;
    }
    case 2: {
      return "originOfGoods";
      break;
    }
    case 3: {
      return "documentaryCredit";
      break;
    }
    case 4: {
      return "placeOfReceipt";
      break;
    }
    case 5: {
      return "placeOfLoading";
      break;
    }
    case 6: {
      return "placeOfDelivery";
      break;
    }
    case 7: {
      return "placeOfDischarge";
      break;
    }
    case 8: {
      return "invoiceNumber";
      break;
    }
    case 9: {
      return "currency";
      break;
    }
    case 10: {
      return "goods";
      break;
    }
    case 11: {
      return "incoterm";
      break;
    }
    case 12: {
      return "shippingMarks";
      break;
    }
    case 13: {
      return "consignee";
      break;
    }
    case 14: {
      return "invoiceDate";
      break;
    }
    case 15: {
      return "purchaseOrderContract";
      break;
    }
    case 16: {
      return "hsCode";
      break;
    }
    case 17: {
      return "issueDate";
      break;
    }
    case 18: {
      return "shipper";
      break;
    }
    case 19: {
      return "manufacturer";
      break;
    }
    case 20: {
      return "vesselOrFlightNumber";
      break;
    }
    case 21: {
      return "voyage";
      break;
    }
    case 22: {
      return "preCarriageVesselOrFlightNumber";
      break;
    }
    case 23: {
      return "sealNumber";
      break;
    }
    case 24: {
      return "containerNumber";
      break;
    }
    case 25: {
      return "shipmentDate";
      break;
    }
    case 26: {
      return "truckNumber";
      break;
    }
    case 27: {
      return "documentNote";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_data_AppDocumentCreateCertificateOfOriginRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iD)));
}
export { $isArrayOf_Lapp_data_AppDocumentCreateCertificateOfOriginRequest as $isArrayOf_Lapp_data_AppDocumentCreateCertificateOfOriginRequest };
var $d_Lapp_data_AppDocumentCreateCertificateOfOriginRequest = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentCreateCertificateOfOriginRequest, "app.data.AppDocumentCreateCertificateOfOriginRequest", ({
  iD: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentCreateCertificateOfOriginRequest as $d_Lapp_data_AppDocumentCreateCertificateOfOriginRequest };
//# sourceMappingURL=app.data.-App-Document-Create-Certificate-Of-Origin-Request.js.map
